import React, { useState, useRef, useEffect } from 'react';
import StatsCards from '../../components/ui/StatsCards';
import PaymentMethodIntentionCard from '../../components/ui/PaymentMethodIntentionCard';
import ChartsSection from '../../components/ui/ChartsSection';
import RequestedLicencesTable from '../../components/ui/RequestedLicencesTable';
import UnreadMessages from '../../components/ui/UnreadMessages';

const Dashboard = () => {
  const [dateRange, setDateRange] = useState('Mar - Apr 2025');
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const calendarRef = useRef(null);

  const dateRanges = [
    { label: 'Mar - Apr 2025', value: 'Mar - Apr 2025' },
    { label: 'Jan - Feb 2025', value: 'Jan - Feb 2025' },
    { label: 'Nov - Dec 2024', value: 'Nov - Dec 2024' },
    { label: 'Sep - Oct 2024', value: 'Sep - Oct 2024' },
  ];
  
  const getCurrentDate = () => {
    const today = new Date();
    const options = { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    };
    return today.toLocaleDateString('en-US', options);
  };

  // Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setIsCalendarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleDateRangeSelect = (range) => {
    setDateRange(range);
    setIsCalendarOpen(false);
  };

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-4xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-sm text-gray-500 mt-1">{getCurrentDate()}</p>
        </div>
        
        {/* Date Range Selector */}
        <div className="relative" ref={calendarRef}>
          <button
            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
            className="flex items-center gap-2 bg-white border border-gray-300 rounded-xl px-4 py-2 text-sm font-medium text-gray-700 hover:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent shadow-sm transition-colors"
          >
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            {dateRange}
            <svg className={`w-4 h-4 text-gray-400 transition-transform ${isCalendarOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {/* Calendar Dropdown */}
          {isCalendarOpen && (
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border border-gray-200 py-2 z-50">
              <div className="px-3 py-2 border-b border-gray-100">
                <p className="text-xs font-semibold text-gray-500 uppercase">Select Date Range</p>
              </div>
              <div className="py-1">
                {dateRanges.map((range, index) => (
                  <button
                    key={index}
                    onClick={() => handleDateRangeSelect(range.value)}
                    className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                      dateRange === range.value
                        ? 'bg-emerald-50 text-emerald-600 font-medium'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    {range.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Stats Cards */}
      <StatsCards />

      {/* Requested licences directly below cards */}
      <RequestedLicencesTable />

      {/* Payment method intention (by customer-selected intention on invoices) */}
      <PaymentMethodIntentionCard />

      {/* Charts Section - 8fr / 4fr grid */}
      <div className="grid grid-cols-12 gap-6">
        {/* Left Column - 8fr */}
        <div className="col-span-8 space-y-6">
          <ChartsSection />
        </div>

        {/* Right Column - 4fr */}
        <div className="col-span-4 space-y-6">
          <UnreadMessages />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;


